import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FileText } from "lucide-react";
import { KnowledgeBaseDetailsDialog } from "./components/knowledge-base/KnowledgeBaseDetailsDialog";
import { KnowledgeBaseList } from "./components/knowledge-base/KnowledgeBaseList";
import { DocumentWithMetadata } from "@/types/knowledge/knowledge-base";

const KnowledgeBasePage = () => {
  const [selectedDocument, setSelectedDocument] = useState<DocumentWithMetadata | null>(null);
  const [isDocumentDetailsOpen, setIsDocumentDetailsOpen] = useState(false);
  const [error, setError] = useState<string>("");
  const [searchParams] = useSearchParams();

  const handleDocumentClick = (document: DocumentWithMetadata) => {
    setSelectedDocument(document);
    setIsDocumentDetailsOpen(true);
  };

  useEffect(() => {
    const documentId = searchParams.get("document");
    if (documentId) {
      // When a document ID is in the URL, we'll open the dialog
      // The dialog will handle loading the document details
      setIsDocumentDetailsOpen(true);
      setError("");
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-[#F9FAFC]">
      <div className="container mx-auto px-4 py-8 max-w-[1920px]">
        <div className="w-full">
          <div className="flex items-center mb-8">
            <div className="h-10 w-10 rounded-full bg-genie-primary/10 flex items-center justify-center mr-4">
              <FileText className="h-5 w-5 text-genie-primary" />
            </div>
            <h1 className="text-3xl font-bold text-[#222B45]">Knowledge Base</h1>
          </div>
          {error && (
            <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-700">{error}</p>
            </div>
          )}
          <div className="p-8 bg-white rounded-lg shadow-md">
            <KnowledgeBaseList onDocumentClick={handleDocumentClick} />
          </div>
          <KnowledgeBaseDetailsDialog
            isOpen={isDocumentDetailsOpen}
            onClose={() => {
              setIsDocumentDetailsOpen(false);
              setSelectedDocument(null);
            }}
            document={selectedDocument}
            onError={(error) => setError(error)}
          />
        </div>
      </div>
    </div>
  );
};

export default KnowledgeBasePage;
